import { Component, Injector, OnInit, inject } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { PageKind, entityState, UiModeType, } from 'jk-service';
import { StkmaService, templateUrlConfigStk } from './../_service_stk';
import { StkmaEditComponent, } from './../_edit_stk';
import { AdvComModule, jkSingleComponent, } from 'jk-advcom';
import { StockView03Component } from '../stock-view03/stock-view03.component';


@Component({
  selector: 'app-stkpi01',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    AdvComModule,
    JackBaseComponentModule,
    StockView03Component,
  ],
  templateUrl: './stkpi01.component.html',//templateUrlConfigStk.stkpi01,
  styleUrls: ['./stkpi01.component.scss'],
})
export class Stkpi01PkgComponent extends jkSingleComponent implements OnInit {
  override _programId = 'stkpi01';
  constructor() {
    super();
    this.srv = new StkmaService();
    this.uiMode = UiModeType.dialog;
    this.title = '股票代號建立作業';
    //this.gridInitOpt = { programId: this.programId, sortField: 'MA001', sort: 'asc', defaultSort: null, pageKind: PageKind.master };
    this.qbeConfig.addField = 'MA002,MA006,MA047';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = StkmaEditComponent;

    //this.title = '商品基本資料建立'; //###
    this.isCheckPower = false; // ###
    this.gridInitOpt = {
      programId: this.programId,
      sortField: 'MA001',
      sort: 'asc',
      defaultSort: null,
      pageKind: this.pageKind,
    }; // ###
    //this.masterdEditPage = StkmaEditComponent; // ###
    //this.setEntityEvent(this.srv);
    this.addOpenwinLoadOption('STKMA', 'W01', 'W', [], this.stkmaList);

    //this.constructorInit();
  }
  // 以下是自訂
  stkmaList: any[] = [];

  get stockno(): string {
    if (this.srv && this.srv.item)
      return this.srv.item.MA001
    else
      return '';
  };



}
